import { createContext } from 'react';
import { AxiosInstance } from 'axios';

import { activityTrackApi } from 'api/activityTrack';

export const ActivityTrackClientContext = createContext<AxiosInstance>(activityTrackApi);
